import { Skeleton } from '@monksflow/monks-ui';

/**
 * Loading placeholder for an artifact card. Mirrors the `AssetCard` frame that
 * `ArtifactCard` renders (h-48 thumbnail inset, p-4 body, subtext line,
 * title/description block, tag row) so the grid keeps its shape while artifacts
 * load instead of flashing blank outlines.
 */
export function ArtifactCardSkeleton() {
  return (
    <div
      className="flex flex-col overflow-hidden rounded-lg border border-border-light bg-card"
      data-testid="artifact-card-skeleton"
    >
      {/* Thumbnail block — matches AssetCard's `h-48 p-3 pb-0` inset. */}
      <div className="relative h-48 shrink-0 p-3 pb-0">
        <Skeleton className="size-full rounded-lg" />
      </div>

      <div className="flex flex-1 flex-col p-4">
        {/* Subtext line (date). */}
        <Skeleton className="mb-2 h-4 w-24" />

        {/* Title + description block (AssetCard reserves min-h-[48px] mb-5). */}
        <div className="mb-5 flex min-h-[48px] flex-col gap-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
        </div>

        {/* Tag row (kind + version pills), pinned to the bottom like the card. */}
        <div className="mt-auto flex items-center gap-1">
          <Skeleton className="h-6 w-16 rounded-full" />
          <Skeleton className="h-6 w-10 rounded-full" />
        </div>
      </div>
    </div>
  );
}
